import { Branch } from '@anghami/neoanalytics/dist/sdks/branch';

let _branch: Branch;

export type DeeplinkAction = Parameters<Branch['getBranchLink']>[2];

const getBranchDeepLink = async (
	pathname: string,
	isShort = false,
	deeplinkAction?: DeeplinkAction
) => {
	if (!_branch) {
		_branch = new Branch();
	}

	return _branch.getBranchLink(pathname, isShort, deeplinkAction);
};

export const deeplinkIntoAppUsingBranch = async (
	pathname: string,
	isShort = false,
	deeplinkAction?: DeeplinkAction
) => {
	const generatedLink = await getBranchDeepLink(pathname, isShort, deeplinkAction);
	// remove ios_url and android_url query params from generated link
	const url = new URL(generatedLink);
	url.searchParams.delete('$ios_url');
	url.searchParams.delete('$android_url');
	url.searchParams.delete('$fallback_url');
	console.log('Deeplinking to URL:', url.toString());
	window.location.href = url.toString();
};
